export interface TrackingSession {
    id: number;
    accessedDate: Date;
}
export interface UserEntity {
    id: number;
    username: string;
    email: string;
    enabled: boolean;
    verified: boolean;
    activated: boolean;
    insertionDate: string;
    modifiedDate: string;
    roles: string[];
    name?: string;
    trackingSession?: TrackingSession;
}

export class User {
    id: number;

    username: string;

    email: string;

    enabled: boolean;

    verified: boolean;

    activated: boolean;

    creationDate: Date;

    modifiedDate: Date;

    roles: string[];

    name?: string;

    trackingSession?: TrackingSession;

    constructor(entity: UserEntity) {
        this.id = entity.id;
        this.username = entity.username;
        this.email = entity.email;
        this.enabled = entity.enabled;
        this.verified = entity.verified;
        this.activated = entity.activated;
        this.creationDate = new Date(entity.insertionDate);
        this.modifiedDate = new Date(entity.modifiedDate);
        this.roles = entity.roles;
        this.name = entity.name;
        this.trackingSession = entity.trackingSession;
    }
}
